export const TURNSTILE_RESET_EVENT = 'turnstile-reset';
export const TURNSTILE_ACTION =
  process.env.REACT_APP_TURNSTILE_ACTION || 'lead_capture';
